import styled from "styled-components";
import { TextField } from "@mui/material";

export const Container = styled.div`
  width: 100%;
`;

export const ContainerBox = styled.div`
  align-items: center;
  display: flex;
  justify-content: center;
  flex-direction: column;
  margin-top: 20px;
  padding: 0 20px;
`;

export const ComponentsArea = styled.div`
  align-items: center;
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  justify-content: center;
  width: 100%;
  max-width: 800px;
  margin: 0 auto;
`;

export const InputsArea = styled.div`
  max-width: 50%;
  display: flex;
  margin: auto;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 10px;
`;

export const DataTitle = styled.span`
  color: #136905;
  font-size: 24px;
  font-weight: bold;
  text-align: center;
  text-transform: uppercase;
  margin: 20px auto;
  padding: 15px 30px;
  background: #ffffff;
  border-radius: 12px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  border: 2px solid #e8f5e8;
`;

export const DataArea = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  background: #ffffff;
  border-radius: 12px;
  padding: 20px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  border: 2px solid #e3f2fd;
  margin: 10px;
  min-width: 300px;
`;

export const DataRow = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin: 10px 0;
  width: 100%;
  align-items: center;
`;

export const DataGroup = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 8px 16px;
  background: #f8f9fa;
  border-radius: 8px;
  border-left: 4px solid #1976d2;
  margin: 2px 0;
  gap: 10px;
`;

export const CopyButton = styled.div`
  margin-bottom: 20px;
  display: flex;
  justify-content: center;
  width: 100%;
`;

export const SingleDataCard = styled.div`
  background: #ffffff;
  border-radius: 16px;
  padding: 30px;
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.12);
  border: 2px solid #e3f2fd;
  margin: 20px auto;
  max-width: 800px;
  width: 100%;
`;

export const UserDataBlock = styled.div`
  margin-bottom: 20px;
  padding: 15px;
  background: #f8f9fa;
  border-radius: 12px;
  border-left: 4px solid #1976d2;
  
  &:last-child {
    margin-bottom: 0;
  }
`;

export const UserHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 10px;
`;

export const IndividualCopyButton = styled.button`
  background: #1976d2;
  color: white;
  border: none;
  border-radius: 8px;
  padding: 8px 12px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  
  &:hover {
    background: #1565c0;
    transform: translateY(-1px);
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
  }
  
  &:active {
    transform: translateY(0);
  }
`;

export const DataSubtitle = styled.span`
  color: #004d93;
  font-size: 18px;
  font-weight: bold;
  text-align: left;
  text-transform: uppercase;
  margin: 0;
  flex: 1;
`;

export const DataLabel = styled.span`
  color: #868383;
  font-size: 15px;
  text-align: center;
  min-width: 80px;
`;

export const DataValue = styled.span`
  font-size: 18px;
  font-weight: bold;
  text-align: center;
  color: #1976d2;
`;

export const FormRow = styled.div`
  width: 100%;
  margin-bottom: 16px;
`;

export const FormSection = styled.div`
  width: 100%;
  max-width: 800px;
  margin: 0 auto;
  padding: 20px;
`;

export const SectionTitleOld = styled.h3`
  color: #004d93;
  font-size: 20px;
  font-weight: bold;
  text-align: center;
  text-transform: uppercase;
`;

// Novos estilos para o formulário de requerimento
export const FormContainer = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 20px;
`;

export const SectionContainer = styled.div`
  margin-bottom: 40px;
  background: #ffffff;
  border-radius: 12px;
  padding: 30px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  border-left: 5px solid #1976d2;
`;

export const SectionTitle = styled.h2`
  color: #1976d2;
  font-size: 24px;
  font-weight: 700;
  text-align: center;
  text-transform: uppercase;
  margin-bottom: 30px;
  padding-bottom: 15px;
  border-bottom: 3px solid #e3f2fd;
  letter-spacing: 1px;
`;

export const SectionSubtitle = styled.h3`
  color: #424242;
  font-size: 18px;
  font-weight: 600;
  margin: 25px 0 20px 0;
  padding: 10px 15px;
  background: #f5f5f5;
  border-radius: 8px;
  border-left: 4px solid #ff9800;
`;

export const FieldRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  margin-bottom: 20px;
`;

export const FieldGroup = styled.div`
  flex: 1;
  min-width: 250px;
  
  @media (max-width: 768px) {
    min-width: 100%;
  }
`;

export const FieldLabel = styled.label`
  display: block;
  color: #424242;
  font-size: 14px;
  font-weight: 600;
  margin-bottom: 8px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
`;

export const FieldInput = styled(TextField)`
  & .MuiOutlinedInput-root {
    border-radius: 8px;
    background: #fafafa;
    
    &:hover {
      background: #f0f0f0;
    }
    
    &.Mui-focused {
      background: #ffffff;
    }
  }
  
  & .MuiInputLabel-root {
    color: #666;
    font-weight: 500;
  }
  
  & .MuiOutlinedInput-notchedOutline {
    border-color: #e0e0e0;
    border-width: 2px;
  }
  
  & .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline {
    border-color: #1976d2;
  }
  
  & .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline {
    border-color: #1976d2;
    border-width: 2px;
  }
`;

export const RadioGroup = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  margin-top: 10px;
`;

export const RadioOption = styled.label`
  display: flex;
  align-items: center;
  cursor: pointer;
  padding: 8px 16px;
  background: #f5f5f5;
  border-radius: 20px;
  border: 2px solid #e0e0e0;
  transition: all 0.3s ease;
  
  &:hover {
    background: #e3f2fd;
    border-color: #1976d2;
  }
  
  input[type="radio"] {
    margin-right: 8px;
    accent-color: #1976d2;
  }
  
  span {
    color: #424242;
    font-weight: 500;
    font-size: 14px;
  }
`;

export const CheckboxGroup = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 15px;
  margin-top: 10px;
`;

export const CheckboxOption = styled.label`
  display: flex;
  align-items: center;
  cursor: pointer;
  padding: 6px 12px;
  background: #f5f5f5;
  border-radius: 16px;
  border: 2px solid #e0e0e0;
  transition: all 0.3s ease;
  
  &:hover {
    background: #e3f2fd;
    border-color: #1976d2;
  }
  
  input[type="checkbox"] {
    margin-right: 6px;
    accent-color: #1976d2;
  }
  
  span {
    color: #424242;
    font-weight: 500;
    font-size: 14px;
  }
`;

export const ButtonContainer = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 40px;
  padding: 30px;
  background: #ffffff;
  border-radius: 12px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
`;

export const ButtonGroup = styled.div`
  display: flex;
  gap: 20px;
  flex-wrap: wrap;
  justify-content: center;
  
  @media (max-width: 768px) {
    flex-direction: column;
    width: 100%;
  }
`;

export const FormDivider = styled.div`
  height: 2px;
  background: linear-gradient(90deg, transparent, #1976d2, transparent);
  margin: 40px 0;
  border-radius: 1px;
`;
